import template from './list-filter.component.html';
import { AttributeFilterController } from '../attribute-filter.component';

class ListFilterController extends AttributeFilterController {
	constructor() {
		'ngInject';
		super();
	}

	$onInit() {
		this.setHelp();
	}

	setHelp() {
		this.getHelp({ help: 'list' });
	}

	toggleAnyValue() {
		this.attr.anyValue = !this.attr.anyValue;
	}

	addValue() {
		if (this.listFilterForm.$valid) {
			super.addValue();
		} else {
			super.validateForm(this.listFilterForm);
		}
	}

	getForm($index) {
		return this[`valueForm${$index}`];
	}

	getFormField($index, field) {
		return this.getForm($index)[`${field}`];
	}

	// getErrorType($index) {
	// 	return super.getErrorType($index);
	// }
}

export const listFilterComponent = {
	template,
	controller: ListFilterController,
	controllerAs: 'vm',
	bindings: {
		attr: '<',
		getHelp: '&'
	}
};
